function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: 23px;\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  .primary-data {\n    &:before {\n      position: absolute;\n      content: '';\n      border-radius: 5px;\n      border: 4px solid\n        ", ";\n      top: 7px;\n      left: -2px;\n    }\n    &:after {\n      position: absolute;\n      top: 17px;\n      left: 2px;\n      height: calc(98%);\n      border-left-width: 1px;\n      border-left-style: ", ";\n      border-left-color: ", ";\n      content: '';\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 16px;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import { defaultTheme } from '../../../utils';
import Text from '../../atoms/Text';
import styled from 'styled-components';
var TrackingListContainer = styled.div(_templateObject());
var TrackingTitle = styled.div(_templateObject2());
var ListRow = styled.div(_templateObject3(), function (props) {
  return props.state === 'CURRENT' ? props.theme.status.successColor : props.state === 'NEXT' ? props.theme.lightBullet : props.state === 'EXPIRED' ? props.theme.status.errorColor : props.theme.textColor;
}, function (props) {
  return props.state === 'PREVIOUS' ? 'solid' : 'dashed';
}, function (props) {
  return props.last ? props.theme.textColorOnPrimary : props.state === 'PREVIOUS' ? props.theme.textColor : props.theme.labelBackgroundColor;
});

var TrackingList = function TrackingList(_ref) {
  var list = _ref.list,
      title = _ref.title,
      containerClass = _ref.containerClass,
      rest = _objectWithoutPropertiesLoose(_ref, ["list", "title", "containerClass"]);

  return /*#__PURE__*/React.createElement(TrackingListContainer, {
    className: containerClass
  }, !!title && /*#__PURE__*/React.createElement(TrackingTitle, null, /*#__PURE__*/React.createElement(Text, {
    text: title,
    size: "regular",
    variant: "semiBold"
  })), list && list.map(function (item, index, list) {
    return (item === null || item === void 0 ? void 0 : item.primaryData) && /*#__PURE__*/React.createElement(ListRow, _extends({
      key: index,
      state: item.state,
      last: list.length - 1 === index
    }, rest), /*#__PURE__*/React.createElement(Text, {
      referenceClass: "primary-data",
      text: item.primaryData,
      size: "iconLabel"
    }), !!item.secondaryData && /*#__PURE__*/React.createElement(Text, {
      text: item.secondaryData,
      color: "bodyTextLight",
      size: "copyrightText"
    }));
  }));
};

TrackingList.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape({
    primaryData: PropTypes.string.isRequired,
    secondaryData: PropTypes.string,
    state: PropTypes.string
  })).isRequired,
  containerClass: PropTypes.string
} : {};
TrackingList.defaultProps = {
  theme: defaultTheme,
  title: '',
  containerClass: ''
};
export default TrackingList;